// NPM Imports
import React, { Component } from "react";
import Modal from "react-responsive-modal";
import APPROVE from "../../assets/Accepted.svg";
// Comonents Imports
// import { Button } from "../../commonComponents";
import AcceptanceGraphic from "../../assets/Acceptance-Graphic.png";

// import StatusDropdown from "../QuotationTopbar/StatusDropdown";

class DocSubmittedStatusUpdate extends Component {
  _onClose = () => {
    this.props.toggleModalPopUp("docSubmittedConfirmationPopup", false);
  };

  render() {
    return (
      <Modal open onClose={this._onClose} center>
        <div
          className="quotationtopbar-container"
          data-test="quotationtopbar-container">
          <div className="docstatus-accptancereject-image">
            <div className="docstatus-confirm-text">
              <div className="doc-confirm-seal">
                <img
                  src={APPROVE}
                  alt="Approve badge"
                  className="document-sent-confirmation-image"
                />
              </div>
              <div className="docstatus-confirm-title">Thanks for filling!</div>
              <div className="docstatus-accept-subtitle">
                We
                <span aria-label="quot-single" role="img">
                  &#8216;
                </span>
                re processing your document. You will receive an email shortly
                requesting your signature on this document.
              </div>
              <div className="acceptance-docstatus-confirm-footer">
                <span aria-label="bulb" role="img">
                  &#128161;
                </span>{" "}
                Keep the url of this document handy to access it anytime
              </div>
            </div>

            <img
              src={AcceptanceGraphic}
              alt="Revv"
              className="document-sent-confirmation-image"
            />
          </div>
        </div>
      </Modal>
    );
  }
}

export default DocSubmittedStatusUpdate;



// WEBPACK FOOTER //
// ./src/components/DocumentApprovalPopupNew/DocSubmittedStatusUpdate.js